module.exports = __webpack_public_path__ + "img/armada-kapal-w.1480ca26.svg";